import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox, useTheme } from "@mui/material";
import { tokens } from "../../assets/theme";


export default function Checkbox(props) {

    const { id, name, label, value, onChange, disabled, sx } = props;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const convertToDefEventPara = (name, value) => ({
        target: {
            id, name, value, type: "checkbox", checked: value
        }
    })

    return (
        <FormControl sx={sx}>
            <FormControlLabel
                control={<MuiCheckbox
                    id={id}
                    name={name}
                    disabled={disabled}
                    sx={{
                        color: colors.primary[100],
                        '&.Mui-checked': {
                          color: colors.dashbordGreen[600],
                        },
                      }}
                    checked={value}
                    onChange={e => onChange(convertToDefEventPara(name, e.target.checked))}
                />}
                label={label}
            />
        </FormControl>
    )
}